/* istanbul ignore file */

import * as MobileAppPlatformKind from '../../constants/mobile-app/platform-kind';
import * as MobileAppKind from '../../constants/mobile-app/app-kind';
import * as MobileAppBiometricsKind from '../../constants/mobile-app/biometrics-kind';
export const getMobileAppVersion = () => {
  return global?.window?.mobileAppVersion || null;
};
export const getMobileAppKind = () => {
  return global?.window?.mobileAppKind || null;
};
export const isUpgradeMobileApp = () => getMobileAppKind() === MobileAppKind.UPGRADE_MOBILE;
export const isMerchantMobileApp = () => getMobileAppKind() === MobileAppKind.MERCHANT_MOBILE;
export const getMobileAppAuthHelperRememberUsername = () => {
  return global?.window?.mobileAppAuthHelperRememberUsername || undefined;
};
export const getMobileAppAuthHelperBiometrics = () => {
  const envBiometrics = global?.window?.mobileAppAuthHelperBiometrics;
  if (MobileAppBiometricsKind[envBiometrics]) {
    return envBiometrics;
  }
  return MobileAppBiometricsKind.NONE;
};
export const getMobileAppPlatform = () => {
  return global?.window?.mobileAppPlatform;
};
export const isMobileAppAndroidShareEnabled = () => {
  return getMobileAppPlatform() === MobileAppPlatformKind.ANDROID && global?.window?.mobileAppShareEnabled === true;
};
export const getMobileAppInsets = () => {
  const {
    top = 0,
    left = 0,
    right = 0,
    bottom = 0
  } = global?.window?.mobileAppInsets || {};
  return {
    top,
    right,
    bottom,
    left
  };
};